import { createContext, useContext, useState } from 'react';

import { Map } from 'mapbox-gl';

interface MapContext {
  mapLayersLoaded: boolean;
  setMapLayersLoaded: (isLoaded: boolean) => void;
  map: Map | undefined;
  setMap: (newMap: Map) => void;
  isMapPreloaded: boolean;
  setIsMapPreloaded: (newValue: boolean) => void;
}

const mapContextInitialValue = {
  mapLayersLoaded: false,
  setMapLayersLoaded: () => {},
  map: undefined,
  setMap: () => {},
  isMapPreloaded: false,
  setIsMapPreloaded: () => {},
};

const MapContext = createContext<MapContext>(mapContextInitialValue);
MapContext.displayName = 'MapContext';

const MapProvider = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  const [mapLayersLoaded, setMapLayersLoaded] = useState(false);
  const [map, setMap] = useState<Map>();
  const [isMapPreloaded, setIsMapPreloaded] = useState(false);

  const value: MapContext = {
    mapLayersLoaded,
    setMapLayersLoaded,
    map,
    setMap,
    isMapPreloaded,
    setIsMapPreloaded,
  };

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};

const useMap = (): MapContext => useContext(MapContext);

export { MapContext, MapProvider, useMap };
